<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="_width" :height="_height" :spin="spin" :rtl="rtl" viewBox="0 0 1024 1024" preserveAspectRatio="xMidYMid meet" fill="" role="presentation" ref="host">
    <g>
      <path data-follow-fill="currentColor" d="M282.8 331.7c.8 12.7 1.7 25.1 2.8 37.2 1.1 12.1 2.4 23 4 32.5h19.9l42.3-102.2H453v424.9c-13.9 2-26.8 4.3-38.8 7.2-12 2.9-23.9 6.2-35.6 10V762h266.7v-20.7c-11.2-4.4-22.8-7.7-34.8-10-11.9-2.4-24.9-4.8-38.8-7.2V299.2h100.4L714 401.4h21c1.6-10 2.8-21.1 3.6-33.2.8-12.1 1.6-24.5 2.4-37.2.8-12.3 1.5-24.5 2-36.8.6-11.9.8-22.6.8-32.2H279.9c0 9.5.2 20.5.8 32.5.6 12.2 1.2 24.7 2.1 37.2zM72 72h160v160H72zm815 815h-26v-20h6v-6h20zm-59.2 0h-33.2v-20h33.2v20zm-66.5 0H728v-20h33.2v20zm-66.5 0h-33.2v-20h33.2v20zm-66.5 0h-33.2v-20h33.2v20zm-66.4 0h-33.2v-20h33.2v20zm-66.5 0h-33.2v-20h33.2v20zm-66.5 0h-33.2v-20h33.2v20zm-66.5 0h-33.2v-20h33.2v20zm-66.4 0h-33.2v-20H296v20zm-66.5 0h-33.2v-20h33.2v20zm-66.5 0h-26v-26h20v6h6z" :fill="_fill" />
      <path
        data-follow-fill="currentColor"
        d="M157 827.8h-20v-33.2h20v33.2zm0-66.5h-20V728h20v33.3zm0-66.5h-20v-33.2h20v33.2zm0-66.5h-20v-33.2h20v33.2zm0-66.4h-20v-33.2h20v33.2zm0-66.5h-20v-33.2h20v33.2zm0-66.5h-20v-33.2h20v33.2zm0-66.5h-20v-33.2h20v33.2zm0-66.4h-20v-33.2h20V296zm0-66.5h-20v-33.2h20v33.2zm0-66.5h-20v-26h26v20h-6zm670.8-6h-33.2v-20h33.2v20zm-66.5 0H728v-20h33.2v20zm-66.5 0h-33.2v-20h33.2v20zm-66.5 0h-33.2v-20h33.2v20zm-66.4 0h-33.2v-20h33.2v20zm-66.5 0h-33.2v-20h33.2v20zm-66.5 0h-33.2v-20h33.2v20zm-66.5 0h-33.2v-20h33.2v20zm-66.4 0h-33.2v-20H296v20zm-66.5 0h-33.2v-20h33.2v20zm657.5 6h-20v-6h-6v-20h26zm0 664.8h-20v-33.2h20v33.2zm0-66.5h-20V728h20v33.3zm0-66.5h-20v-33.2h20v33.2zm0-66.5h-20v-33.2h20v33.2zm0-66.4h-20v-33.2h20v33.2zm0-66.5h-20v-33.2h20v33.2zm0-66.5h-20v-33.2h20v33.2zm0-66.5h-20v-33.2h20v33.2zm0-66.4h-20v-33.2h20V296zm0-66.5h-20v-33.2h20v33.2z"
        :fill="_fill"
      />
      <path data-follow-fill="currentColor" d="M792 72h160v160H792zM72 792h160v160H72zm720 0h160v160H792z" :fill="_fill" />
    </g>
  </svg>
</template>
<script setup>
import { ref, computed, onMounted, onUpdated } from 'vue';
const props = defineProps({
  width: {
    type: [Number, String],
    required: false
  },
  height: {
    type: [Number, String],
    required: false
  },
  stroke: {
    type: String,
    required: false
  },
  fill: {
    type: String,
    required: false
  },
  color: {
    type: String,
    required: false
  },
  spin: {
    type: Boolean,
    required: false
  },
  rtl: {
    type: Boolean,
    required: false
  }
});
const size = '1em';

const _fill = computed(() => props.fill || props.color || undefined);
const _stroke = computed(() => props.stroke || props.color || undefined);
const _width = computed(() => props.width || size || undefined);
const _height = computed(() => props.height || size || undefined);
const host = ref(null);

onMounted(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
onUpdated(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
</script>

<style scoped>
svg[spin='true'] {
  animation: iconpark-spin 1s infinite linear;
}

svg[spin='true'][rtl='true'] {
  animation: iconpark-spin-rtl 1s infinite linear;
}

svg[rtl='true'] {
  transform: scaleX(-1);
}
@keyframes iconpark-spin {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes iconpark-spin-rtl {
  0% {
    -webkit-transform: scaleX(-1) rotate(0);
    transform: scaleX(-1) rotate(0);
  }

  100% {
    -webkit-transform: scaleX(-1) rotate(360deg);
    transform: scaleX(-1) rotate(360deg);
  }
}
</style>
